<template>
  <button type="button" class="ms-sign-in-button" @click="emit('click')">
    <div class="ms-sign-in-button-content-wrapper">
      <div class="ms-sign-in-button-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" aria-hidden="true">
          <rect x="1"  y="1"  width="9" height="9" fill="#f25022"/>
          <rect x="1"  y="11" width="9" height="9" fill="#00a4ef"/>
          <rect x="11" y="1"  width="9" height="9" fill="#7fba00"/>
          <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
        </svg>
      </div>
      <span class="ms-sign-in-button-contents">{{ _('Sign in with Microsoft') }}</span>
    </div>
  </button>
</template>

<script setup lang="ts">
const _ = useNuxtApp().$translate as (key: string) => string
const emit = defineEmits(['click'])
</script>

<style scoped>
.ms-sign-in-button {
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  border: 1px solid #8c8c8c;
  border-radius: 0;
  box-sizing: border-box;
  color: #5e5e5e;
  cursor: pointer;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
  font-size: 15px;
  white-space: nowrap;
  font-weight: 600;
  height: 41px;
  padding: 0 12px;
  width: 100%;
  transition: background-color 0.1s ease;
}

.ms-sign-in-button:hover {
  background-color: #f3f3f3;
}

.ms-sign-in-button:active {
  background-color: #e6e6e6;
}

.ms-sign-in-button-content-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.ms-sign-in-button-icon {
  display: block;
  height: 21px;
  margin-right: 10px;
  width: 21px;
  flex-shrink: 0;
}
</style>
